<template>
  <div class="main-container">

    <form class="text-center" 
        enctype="multipart/form-data" novalidate
        @drop="filesDropped"
        v-if="_isEmpty || _isError || _isIncomplete"
      >

      <div class="upload-dropbox">
        <input type="file" 
            class="upload-input-file" 
            ref="fileInput"
            name="ufile" 
            @change="filesChanged"
            @click="onClickFileInput"
            :accept="accept" />
          <!-- <font-awesome-icon class="upload-icon" icon="upload" /> -->
          <!-- <b-icon icon="alert-triangle" font-scale="4"></b-icon> -->
          <b-icon-alert-triangle font-scale="4"></b-icon-alert-triangle>
          <div v-if="_isError" class="upload-hint">{{errorText}}</div>
          <p class="upload-hint">{{hint}}</p>
      </div>
    </form>



    <div v-if="_isOk" class="file-descr ">
      {{objectDescr}}
    </div>

    <div v-show="_isUploading || _isDeleting">
      <div >{{textStatus}}</div>
    </div>

    <div v-show="_isUploading || _isDeleting"
        class="spin-icon-box">
      <!-- <font-awesome-icon icon="circle-notch" class="spin-icon fa-spin align-middle" /> -->
      <!-- <b-icon icon="gear" animation="spin" font-scale="4" class="align-middle"></b-icon> -->
      <b-icon-gear animation="spin" font-scale="4" class="align-middle"></b-icon-gear>
      <div>
        <b-button class="mt-2" variant="danger" @click="cancelUpload">Cancel</b-button>
      </div>
    </div>




    <b-button variant="danger" size="sm"
        @click="deleteObject"
        class="delete-button"
        v-show="_isOk || _isError || _isIncomplete">
      <!-- <font-awesome-icon icon="times" /> -->
      <!-- <b-icon icon="x" font-scale="1.5"></b-icon> -->
      <b-icon-x font-scale="1.5"></b-icon-x>
    </b-button>

    <div v-show="_isOk && getAltIcon==''">
      <img :src="src"
        class="img-thumbnail img-fluid preview" />
    </div>

    <div class="icon-box" v-if="_isOk && getAltIcon!=''">
    <!-- <font-awesome-icon class="alt-icon" v-if="_isOk && getAltIcon!=''" :icon="getAltIcon" /> -->
      <!-- <b-icon :icon="getAltIcon" font-scale="4"></b-icon> -->
      <b-icon-camera-video v-if="getAltIcon=='camera-video'" font-scale="4"></b-icon-camera-video>
      <b-icon-mic v-if="getAltIcon=='mic'" font-scale="4"></b-icon-mic>
      <b-icon-document-richtext v-if="getAltIcon=='document-richtext'" font-scale="4"></b-icon-document-richtext>
      <b-icon-document v-if="getAltIcon=='document'" font-scale="4"></b-icon-document>
    </div>
      
  </div>
</template>






<script>
// import Vue from 'vue';
import axios from 'axios';
import {debug, defineString, makeUrl, safeEscape, bytesToSize, 
    isMSIE} from './globals';

import { 
  // BIcon,
  BIconAlertTriangle,
  BIconGear,
  BIconX,
  BIconCameraVideo,
  BIconMic,
  BIconDocumentRichtext,
  BIconDocument } from 'bootstrap-vue';

const ST_EMPTY = 0,
  ST_UPLOADING = 1,
  ST_CANCELLING = 2,
  ST_DELETING = 3,
  ST_PAUSED = 4,
  ST_ERROR = 5,
  ST_OK = 6,
  ST_INCOMPLETE = 7;

const DEFAULT_UPLOAD_CHUNK_SIZE = 1048576; // 1 MByte




// const DEFAULT_ALT_ICON = ['far', 'file-alt'];

const HINT_DEFAULT = 'Drag a file here or click to browse';


// for ability to cancel the consult upload request
let CancelToken, CancelTokenSource;



export default {
  components: {
    // BIcon,
    BIconAlertTriangle,
    BIconGear,
    BIconX,
    BIconCameraVideo,
    BIconMic,
    BIconDocumentRichtext,
    BIconDocument
  },

  props: [ 'consultUid',
    'objectId',
    'accept', // image/* - switch to attachType?
    'attachType', // image/video/report
    'uploadHint',
    'altTitle',
    ''
  ],


  data: function() {
    return {
      uploadedFiles: [],
      uploadError: null,
      uploadFieldName: 'ufile',
      imageLoading: true,
      currState: ST_EMPTY,
      src: '',
      showAltIcon: false,
      altIconClass: '',
      altIcon: '',
      uploadHintText: '',
      showThumbnail: false,
      textStatus: '',

      // upload data
      file: null,
      fileName: '',
      contentType: '',
      uploadId: '',
      type: '',
      descr: '',

      ser: '',
      num: '',
      hint: this.hintDefault, //HINT_DEFAULT,
      errorText: ''
    }
  },


  computed: {
    objectData: function() {
      return this.$store.getters['form/singleImageData'](this.objectId);
    },

    objectDataUploadId: function() {
      return (this.objectData != undefined) ? this.objectData.uploadId : ''
    },

    isIncomplete: function() {
      if (this.objectData) {
        const bytes = parseInt(this.objectData.bytes),
          bytesTotal = parseInt(this.objectData.bytesTotal);
        if (bytes >= 0 && bytesTotal > 0 && bytes < bytesTotal) {
          return true
        }
      }
      return false;
    },





    attachedUid: function() {
      // debug('FileUploader computed attachedUid');
      return (this.objectData) ? this.objectData.uid : null
    },

    objectDescr: function() {
      // debug('FileUploader computed objectDescr');
      if (this.objectData == undefined || this.objectData == null) {
        return ''; // ???
      }

      const descr = defineString(this.objectData.descr);
      const fileName = defineString(this.objectData.fileName);
      // const uploadId = defineString(this.objectData.uploadId);

      return (fileName != '')
        ? fileName
        : descr
    },

    _isEmpty() { return this.currState === ST_EMPTY },
    _isUploading() { return this.currState === ST_UPLOADING },
    _isCancelling() { return this.currState === ST_CANCELLING },
    _isDeleting() { return this.currState === ST_DELETING },
    _isPaused() { return this.currState === ST_PAUSED },
    _isError() { return this.currState === ST_ERROR },
    _isOk() { return this.currState === ST_OK },
    _isIncomplete() { return this.currState === ST_INCOMPLETE },
    _status() { return this.currState },

    _Empty() { return  ST_EMPTY },
    _Uploading() { return ST_UPLOADING },
    _Cancelling() { return ST_CANCELLING },
    _Deleting() { return ST_DELETING },
    _Paused() { return ST_PAUSED },
    _Error() { return ST_ERROR },
    _Ok() { return ST_OK },
    _Incomplete() { return ST_INCOMPLETE },


    getAltIcon() {
      if (!this.objectData) return '';

      const contentType = defineString(this.objectData.contentType);

      if (contentType=='image' || contentType.indexOf('image/') >= 0) {
        return ''
      }

      if (contentType=='video' || contentType.indexOf('video/') >= 0) {
        return 'camera-video'; //['far', 'file-video']; //'file-video'
      }

      if (contentType.indexOf('audio/') >= 0) {
        return 'mic'; //'file-audio' //'audio'
      }
      
      if (contentType.indexOf('application/pdf') >= 0) {
        return 'document-richtext'; //['far', 'file-pdf']; //'file-pdf' //'pdf'
      }

      // default
      return 'document'; //DEFAULT_ALT_ICON
    },


    hintDefault() {
      return (this.uploadHint != undefined) ? this.uploadHint : HINT_DEFAULT;
    }


  },


  created() {
    // debug('FileUploader created: CCC _____________________ objectId=' + this.objectId);
    // this.uploadHintText = (this.uploadHint)
    //     ? this.uploadHint
    //     : 'Drag your file(s) here to begin or click to browse';
    this.reset();
  },




  methods: {
// ---------------


    filesDropped(event) {
      debug('FileUploader filesDropped');

      // use this code for IE only!!!
      // filesChanged is not fired in IE
      // if (this.isMSIE) {
      if (isMSIE()) {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer.files.length) {
          debug('FileUploader filesDropped: emit selected-files');
          // this.$emit('selected-files',
          this.$emit('upload-selected',
            { objectId: this.objectId,
              fieldName: 'ufile', 
              fileList: event.dataTransfer.files}); // pass 1st file only?
        } else {
          debug('FileUploader filesDropped: no files dropped');
        }
      } else {
        debug('FileUploader filesDropped: NOT IE11')
      }
    },


    filesChanged(event) {
      debug('FileUploader filesChanged');

      if (event.target.files.length) {
        debug('FileUploader filesChanged: emit selected-files');
        // this.$emit('selected-files',
        this.$emit('upload-selected',
          { objectId: this.objectId,
            fieldName: event.target.name,
            fileList: event.target.files} ); // pass 1st file only?
      } else {
        debug('FileUploader filesChanged: no files changed');
      }
    },


    onClickFileInput() {
      // fix for IE which doesn't fire 'change' event if selected the same file twice
      this.$refs.fileInput.value = null
    },


// ----------------

    reset() {
      // debug('FileUploader reset: RRR_____________________ objectId=' + this.objectId + ', src=' + this.src);

      this.uploadChunkSize =  0;
      this.uploadChunkSize = parseInt( this.$store.getters['config/server'].upload_chunk_size );
      if (Number.isNaN(this.uploadChunkSize) || this.uploadChunkSize <= 0) {
        this.uploadChunkSize = DEFAULT_UPLOAD_CHUNK_SIZE
      }
      debug('FileUploader reset: uploadChunkSize=' + this.uploadChunkSize);



      this.uploadedFiles = [];
      this.uploadError = null;
      this.imageLoaded = true;
      
      this.textStatus = ''; //'Getting preview...';

      // init based on objectData
      this.showThumbnail = false;
      this.uploadId = (this.objectData) ? this.objectData.uploadId : null;
      // this.altIcon = this.getAltIcon();
      this.src = this.objectThumbnailUrl();

      // default hints
      this.hint = this.hintDefault; //HINT_DEFAULT;
      this.errorText = '';

      // reset form to initial state
      if (this.src != '') {
          this.currState = ST_OK;
      } else {
        if (this.isIncomplete) {
          // this.currState = ST_INCOMPLETE;
          this.currState = ST_ERROR;
          this.errorText = 'Incomplete: ' + defineString(this.objectData.fileName)
            + ' (' + bytesToSize(this.objectData.bytes) 
            + '/' + bytesToSize(this.objectData.bytesTotal) + ')';
          this.hint = this.makeRetryHint(this.objectData.fileName);
        } else {
          this.currState = ST_EMPTY;
        }
      }

    },


    makeRetryHint(name) {
      return 'To retry, drag "' + name + '" here or click to browse'
    },



// --------------------------

    upload(formData) {
      debug('FileUploader upload');
      const vm = this;

      this.currState = ST_UPLOADING;
      this.textStatus = 'Uploading...';
      this.altIcon = '';
      this.showThumbnail = false;

      const url = makeUrl('upload.cgi');
      debug('FileUploader upload: ' + this.objectId + ', URL=' + url);

      debug('FileUploader upload: consultUid=' + this.consultUid + ', _isUploading=' + this._isUploading);

      // save upload data in component
      // 1st get to check what has been already uploaded

      this.file = formData.get('ufile');
      this.uploadId = formData.get('upload_id');
      this.type = formData.get('type');
      this.descr = defineString(formData.get('descr'));
      this.ser = defineString(formData.get('ser'));
      this.num = defineString(formData.get('num'));

      debug('FileUploader upload: name=' + this.file.name
        + ' suid=' + this.consultUid
        + ' upload_id=' + this.uploadId
        + ' type=' + this.type
        + ' descr=' + this.descr
        + ' ser=' + this.ser
        + ' num=' + this.num);

      
      const urlGet = makeUrl('upload.cgi'
        + '?suid=' + safeEscape(this.consultUid)
        + '&ufile=' + safeEscape(this.file.name)
        + '&upload_id=' + safeEscape(this.uploadId)
        + '&tmp='+ (new Date().getTime()));

      vm.chunkCount = 0;
      axios.get(urlGet)
        .then(rx => rx.data)
        .then(function(data) {
          debug('FileUploader upload: GET done: ' + vm.objectId + ', result: ' + JSON.stringify(data));

          const result = defineString(data.result);
          debug('FileUploader upload: GET result=' + result);

          // will it work for a deleted file?



          if (result == 'ok') {
            // alert('GET: ' + data.name + ', uploaded=' + data.bytes + ', total=' + data.bytes_total);
            // return;
            const fileSize = vm.file.size;

            const uploadedName = defineString(data.name),
              uploadedBytes = parseInt(data.bytes),
              uploadedTotal = parseInt(data.bytes_total);
              

            if (uploadedName != '' && uploadedTotal != 0
                && (uploadedName != vm.file.name || uploadedTotal != fileSize)) {
              const msgExpected = 'Expecting ' + uploadedName
                  + ', size ' + bytesToSize(uploadedTotal)
                  + ', uploaded ' + bytesToSize(uploadedBytes);

              vm.uploadFailed(msgExpected,
                vm.makeRetryHint(uploadedName));

              return;
            }


            // var start = parseInt(data.bytes);
            debug('FileUploader upload: uploaded bytes=' + uploadedBytes);

            if (uploadedBytes >= 0 && uploadedBytes < fileSize) {
              vm.uploadNextChunk(uploadedBytes);
            } else {
              if (uploadedBytes == fileSize) {
                debug('FileUploader upload: the file is on the server already => upload complete');
                vm.uploadComplete();
              } else {
                vm.uploadFailed('Uploaded part of ' + bytesToSize(uploadedBytes)
                    + ' is out of range [0-' + bytesToSize(fileSize) + ']',
                  'Please delete and re-upload the file');
              }
            }
          } else {
            // var msg = defineString(result.error);
            // if (msg == '') msg = 'Failed to start upload';
            debug('FileUploader upload: result no OK, cannot initiate upload');
            alert('Failed to start upload')
          }

        })
        .catch(function(error1) {
          alert('FileUploader upload: ' + error1);
          // debug('FileUploader upload: CATCH: ' + defineString(error1));
          const errText = defineString(error1);
          debug('FileUploader upload: ERROR: ' + errText);
          vm.errorText = 'Upload Failed'; //errText;
          vm.$emit('upload-error', {objectId: vm.objectId});
          vm.currState = ST_ERROR;

        })
    },



// //////////////////////////////////////////////////////////
    uploadNextChunk(start) {
      const vm = this;

      vm.chunkCount++;

      var end = start + this.uploadChunkSize;
      if (end > this.file.size) end = this.file.size;
      debug('FileUploader uploadNextChunk: CHUNK: ' + vm.chunkCount + ', start=' + start + ', end=' + end);


      var formData = new FormData();

      const blob = this.file.slice(start, end, this.file.type); 

      debug('FileUploader uploadNextChunk: name=' + this.file.name + ', size=' + blob.size + ', start=' + start + ', end=' + end);

      formData.append('ufile', blob, this.file.name);
      formData.append('suid', defineString(this.consultUid));
      formData.append('upload_id', defineString(this.uploadId));
      formData.append('type', this.type); // attach type: image|video|report
      formData.append('descr', this.descr);
      formData.append('ser', this.ser);
      formData.append('num', this.num);

      debug('FileUploader uploadNextChunk: name=' + this.file.name
        + ' suid=' + this.consultUid
        + ' upload_id=' + this.uploadId
        + ' type=' + this.type
        + ' descr=' + this.descr
        + ' ser=' + this.ser
        + ' num=' + this.num);

      // missing Content-Range !!!!
      const url = makeUrl('upload.cgi');

      const contentRange = 'bytes ' + start + '-' + (end-1) + '/' + this.file.size;
      debug('FileUploader uploadNextChunk: contentRange = ' + contentRange);


      // token to cancel the request
      CancelToken = axios.CancelToken;
      CancelTokenSource = CancelToken.source();

      var requestConfig = { headers: {'Content-Range': contentRange },
        cancelToken: CancelTokenSource.token };


      axios.post(url, formData, requestConfig)
        .then(response => {
          const data = response.data;
          debug('FileUploader uploadNextChunk: response: '+JSON.stringify(response));

          const result = defineString(data.result);
          if (result == 'ok') {
            debug('FileUploader uploadNextChunk: ok');

            const range = defineString(response.headers['range']);
            debug('FileUploader uploadNextChunk: response range=' + range);

            var uploadedBytes = -1;
            if (range != '') {
              var rangeParts = range.split('-');
              if (rangeParts && rangeParts.length > 1) {
                uploadedBytes = parseInt(rangeParts[1], 10) + 1;
              }
            }
            debug('FileUploader uploadNextChunk: uploadedBytes=' + uploadedBytes);


            if (uploadedBytes == end) {
              debug('FileUploader uploadNextChunk: chunk ' + vm.chunkCount + ' uploaded');

              if (uploadedBytes < vm.file.size) {
                debug('FileUploader uploadNextChunk: proceed with next chunk');
                vm.uploadNextChunk(uploadedBytes)
              } else {
                debug('FileUploader uploadNextChunk: upload complete');
                vm.uploadComplete();
              }
            }
          } else {
            vm.currState = ST_ERROR;
            var msg = defineString(data.error);
            if (msg == '') msg = 'upload script error';
            vm.uploadFailed(msg, this.hintDefault) // HINT_DEFAULT
          }
        }, error => {
          debug('FileUploader uploadNextChunk: ERROR: ' + JSON.stringify(error));
          var msg = 'Unknown error';
          if (error.response) {
            msg = error.response.status;
          } else {
            if (error.request) {
              msg = 'The request was made but no response was received';
            } else {
              if (error.message) {
                msg = error.message
              }
            }
          }
          vm.uploadFailed(msg,
            this.makeRetryHint(this.file.name))
        }
      )
    },


    uploadComplete() {
      const vm = this;

      // ok
      vm.textStatus = 'Uploaded';

      debug('FileUploader uploadComplete: update images data: '
        + ', type=' + vm.attachType
        + ', uploadId=' + vm.uploadId,
        + ', contentType=' + vm.contentType);


      // vm.$emit('upload-ok', {objectId: vm.objectId});

      debug('FileUploader uploadComplete: expecting change of src here');
      debug('FileUploader uploadComplete: [' + vm.objectId  +'] currState (before) = ' + vm.currState);
      vm.currState = ST_OK;
      debug('FileUploader uploadComplete: [' + vm.objectId + '] currState (after) = ' + vm.currState);

      vm.$store.dispatch('form/setSingleImageData',
        {objectId: vm.objectId,
          attachType: vm.attachType,
          uploadId: vm.uploadId,
          fileName: vm.file.name,
          contentType: vm.file.type,
          descr: vm.descr,
          ser: vm.ser,
          num: vm.num,
          bytes: vm.file.size,
          bytesTotal: vm.file.size});
      debug('FileUploader uploadComplete: descr=' + vm.descr + ', ser=' + vm.ser + ', num=' + vm.num);
      debug('FileUploader uploadComplete: [' + vm.objectId + '] currState (after) = ' + vm.currState);

      
      vm.textStatus = ''; //'Getting preview...';

      vm.src = vm.objectThumbnailUrl();

      vm.$emit('upload-ok', {objectId: vm.objectId});
    },


    uploadFailed(msg, hint) {
      debug('FileUploader uploadFailed: ' + msg);
      alert('Upload failed: ' + msg);
      this.errorText = msg; //'Upload error';
      this.$emit('upload-error', {objectId: this.objectId});
      this.currState = ST_ERROR;
      this.hint = hint;
    },


    

    deleteObject() {
      debug('FileUploader deleteObject: uploadId=' + this.objectId);
      const vm = this;

      this.textStatus = 'Deleting...';

      this.$store.dispatch('form/deleteServerObject', this.objectId)
        .then(() => {
          vm.hint = this.hintDefault; //HINT_DEFAULT;

          if (this.objectData) {
            debug('FileUploader deleteObject: have objectData: ' + JSON.stringify(this.objectData))
          } else {
            debug('FileUploader deleteObject: no objectData')
          }

          vm.src = this.objectThumbnailUrl();
          debug('FileUploader deleteObject: after delete: src=' + vm.src);

          vm.currState = ST_EMPTY;
          vm.textStatus = 'Deleted.';
          debug('FileUploader deleteObject: OK');

          vm.$emit('upload-deleted', {objectId: vm.objectId});

          // update storeForm/images
        },
        // error
        () => {
          vm.src = this.objectThumbnailUrl();
          vm.textStatus = 'Failed to delete.';
          alert('Failed to delete the file');
          debug('FileUploader deleteObject: ERROR');
        });
    },


    objectThumbnailUrl() {
      if (!this.objectData) {
        // debug('FileUploader objectThumbnailUrl: no objectData => EMPTY SRC');
        return ''
      }


      const attachedUid = safeEscape(this.attachedUid),
        uploadId = safeEscape(this.uploadId);
      debug('FileUploader objectThumbnailUrl: objectId=' + this.objectId
        + ', attachedUid=' + attachedUid
        + ', uploadId=' + uploadId);
      if (!this.isIncomplete && (attachedUid != '' || uploadId != '')) {
        const url =  makeUrl('service.cgi?get=object_thumbnail'
            + '&suid=' + safeEscape(this.consultUid)
            + '&attached_uid=' + attachedUid
            + '&upload_id=' + uploadId
            + '&type=' + safeEscape(this.attachType))
            + '&tmp=' + (new Date().getTime());
        return url;
      } else {
        debug('FileUploader objectThumbnailUrl: objectId=' + this.objectId + ' EMPTY SRC');
        return ''
      }
    },


    retryUpload: function() {
      debug('FileUploader retryUpload');
      this.$emit('upload-retry', {objectId: this.objectId});
    },


    cancelUpload() {
      debug('FileUploader cancelUpload');
      if (CancelTokenSource) {

        CancelTokenSource.cancel('Operation canceled by the user.');
      
        this.$emit('upload-error', {objectId: this.objectId});
        this.currState = ST_ERROR;
        this.hint = this.makeRetryHint(this.file.name);
      
      } else {
        debug('Error: CancelTokenSource is not defined');
      }
    }

  }, // methods
}

</script>


<style scoped>
.main-container {
  width:200px;
  min-height:200px;
  position: relative;
  border-radius: 5px;
  border: thin solid  rgb(192, 192, 192);
  margin-left: auto !important;
  margin-right: auto !important;
}


.preview {
    max-height: 198px;
    max-width: 198px;
    height: auto;
    width: auto;

position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.spin-icon-box {
  /* position: absolute;
  left: 75px;
  top: 75px; */
  margin-top: 50px;
  text-align: center;
}

.spin-icon {
  font-size: 3em;
  color: #00BAD5;
}

.alt-icon-box {
  position: absolute;
  left:0px;
  top:0px;
  margin: auto;
  width: 200px;
  height: 200px;
}

.alt-icon {
  font-size: 7em;
  color: #00BAD5;
  margin-top: 45px;
}

.delete-button {
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 999;
}


.file-descr {
  position: absolute;
  left:5px;
  bottom:5px;
  z-index: 998;
  color: #000;
  text-shadow: 1px 0 0 #fff, 0 -1px 0 #fff, 0 1px 0 #fff, -1px 0 0 #fff;
  max-width: 160px;
  overflow: hidden;
  line-height: 1.2em;
}


.text-status {
  position: absolute;
  left:5px;
  top:165px;
  z-index: 998;
  color: #000;
  text-shadow: 1px 0 0 #fff, 0 -1px 0 #fff, 0 1px 0 #fff, -1px 0 0 #fff;
}





/* /// */
.upload-dropbox {
  background: lightcyan;
  border: 1px solid #00BAD5;
  border-radius: 5px;
  color: dimgray;
  position: relative;
  padding: 10px;
  width: 200px;
  height: 200px;
}

/* .upload-dropbox: narrow screen */
@media (max-width: 767px) {
  .upload-dropbox {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}


.upload-dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 5px 5px;
}

.upload-input-file {
  opacity: 0;
  overflow: hidden;
  min-height: 200px;
  width: 100%;
  position: absolute;
  cursor: pointer;
  left: 0px;
  top: 0px;
  margin: 0;
  padding: 0;
}

.upload-icon {
  margin-top: 5;
  font-size: 3em;
  color: #00BAD5;
}

.upload-hint {
  line-height: 1em;
}


.icon-box {
  text-align: center;
  padding-top: 50px;
}

</style>


